<template>
  <div
    id="multiSensorHiL"
    :class="{
      box: true,
      'landscape-box': isLandscape,
      'portrait-box': !isLandscape,
      en: $i18n.locale === 'en-US',
    }"
  >
    <!-- <div id="multiSensorHiL"> -->
    <div
      id="multiSensorHiLModule1"
      :style="{ 'background-image': 'url(' + imageUrl1 + ')' }"
      v-lazy="imageUrl1"
    >
      <div id="multiSensorHiLModule1Text" class="gaiAModule1">
        <div id="multiSensorHiLModule1TextText1" class="module1">
          {{ $t(`${i18nKey}.title`) }}
        </div>
        <div id="multiSensorHiLModule1TextText2" class="module1">
          {{ $t(`${i18nKey}.subtitle`) }}
        </div>
      </div>
    </div>
    <!-- 高精度仿真的自动驾驶“疆域” -->
    <div id="territory">
      <div id="territoryBox" class="wow animate__animated animate__fadeInUp">
        <div id="title">{{ $t(`${i18nKey}.territory.title`) }}</div>
        <div id="img">
          <video
            id="video"
            ref="videoTerritory"
            controlsList="nodownload"
            :controls="false"
            :src="$t(`${i18nKey}.territory.video`)"
            muted
            autoplay
            loop
            x-webkit-airplay="allow"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
          ></video>
        </div>
      </div>
    </div>
    <!-- 合作咨询 -->
    <div class="collaborativeConsulting">
      <div class="title1 wow animate__animated animate__fadeInUp">
        {{ $t(`${i18nKey}.press.title`) }}
      </div>
      <div class="title2 wow animate__animated animate__fadeInUp">
        {{ $t(`${i18nKey}.press.subtitle`) }}
      </div>
      <ul>
        <li
          ref="liRef"
          class="wow animate__animated animate__fadeInUp"
          v-for="(item, index) in collaborativeConsultingList.slice(
            (this.currentPage - 1) * this.pagesize,
            this.currentPage * this.pagesize
          )"
          :key="index"
        >
          <a class="a" :href="item.href" target="_blank">
            <div class="img">
              <img :src="item.icon" alt="" />
            </div>
            <div class="cont">
              <div class="h1">
                {{
                  $t(
                    `${i18nKey}.press.list[${
                      (currentPage - 1) * pagesize + index
                    }].title`
                  )
                }}
              </div>
              <!-- <div class="h2">{{ item.h2 }}</div> -->
              <div class="date">
                <div class="svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                  >
                    <g opacity="0.65">
                      <path
                        d="M6 11C8.76143 11 11 8.76143 11 6C11 3.23857 8.76143 1 6 1C3.23857 1 1 3.23857 1 6C1 8.76143 3.23857 11 6 11Z"
                        stroke="white"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M6.00201 3L6.00171 6.0022L8.12156 8.12205"
                        stroke="white"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                  </svg>
                </div>
                <div>
                  {{ item.date }}
                </div>
              </div>
            </div>
          </a>
        </li>
      </ul>
      <!-- 分页 10条以上显示-->
      <div
        v-if="collaborativeConsultingList.length > 10"
        class="pagination wow animate__animated animate__fadeInUp"
      >
        <el-pagination
          popper-class="selectStyle"
          :popper-append-to-body="false"
          background
          layout="prev, pager, next,sizes,jumper"
          :total="15"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
        >
        </el-pagination>
      </div>
    </div>

    <div id="multiSensorHiLFooter">
      <FooterComponents></FooterComponents>
    </div>
  </div>
</template>

<script>
import FooterComponents from "@/components/FooterComponents.vue";
import WOW from "wowjs";
// 首先引入element-ui中文包
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
// 然后将element-ui中pagination选项改掉
zhLocale.el.pagination = {
  pagesize: "/页",
  total: `共 {total} 条`,
  goto: "跳至",
  pageClassifier: "",
};
export default {
  computed: {
    isLandscape() {
      return Math.abs(window.orientation) === 90;
    },
  },
  components: {
    FooterComponents,
  },
  updated() {
    let lang = localStorage.getItem("lang");
    if (lang == "en-US") {
      this.showTestObject = false;
    } else {
      this.showTestObject = true;
    }
  },
  data() {
    return {
      i18nKey: "ecosphereCooperationSharePlatform",
      imageUrl1: require("@/static/img/HiLbanner.png"),
      showTestObject: true,
      //初始每页的数据条目数据
      pagesize: 10,
      // 前往1页
      currentPage: 1,
      collaborativeConsultingList: [
        {
          icon: require("@/static/img/ecosphere/collaborativeImg1.png"),
          href: "https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488622&idx=1&sn=a58219b8c244091e08c0b15d80548632&chksm=fcd15b39cba6d22f346694a748eb8574ffebeeaa1da0678e68675e000f674aa2e8d4ba75455b&token=185823960&lang=zh_CN#rd",
          h1: "沛岱汽车与足下科技达成战略合作，强强联合提升自动驾驶研发效能",
          h2: "11月2日，自动驾驶精准仿真引领者「沛岱汽车」和国产智能驾驶操作系统开拓者「足下科技」宣布达成战略合作，并签署战略合作协议，双方将联合提升自动驾驶研发效能，共同打造满足市场需求的高效能、高性价比、高核心竞争力的自动驾驶创新解决方案，促进自动驾驶量产落地，共建自动驾驶生态。",
          date: "2023.11.2",
        },
        {
          icon: require("@/static/img/ecosphere/collaborativeImg2.png"),
          href: "https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247488485&idx=1&sn=5163e76e7267e8cc148a5ee7e0753de8&chksm=fcd15cb2cba6d5a48479c40ab34830c67e0b263437e91c1c2961b0e918fd0ca6c6a8fe976523&token=185823960&lang=zh_CN#rd",
          h1: "沛岱汽车与西部智联签署战略合作协议，共创智能网联汽车新未来",
          h2: "沛岱（宁波）汽车技术有限公司（简称“沛岱汽车”）与西部科学城智能网联汽车创新中心（重庆）有限公司（简称“西部智联”）达成战略合作。双方将在深化“自动驾驶仿真测试”技术与工程领域，探索自动驾驶、智能网联、V2X产业应用等方面，开展深度合作。",
          date: "2023.9.1",
        },
        {
          icon: require("@/static/img/ecosphere/collaborativeImg3.png"),
          href: "https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247487109&idx=1&sn=cadd96c637082aff04b760b5f47a93c8&chksm=fcd141d2cba6c8c4d1da1d55f3590fe15331b73e03a8514e38dcd06c36e3e1d79d18670c51c6&token=185823960&lang=zh_CN#rd",
          h1: "沛岱汽车与楚航科技达成战略合作",
          h2: "2022年4月21日，沛岱汽车（PilotD Automotive）与楚航科技（CHUHANG TECH）宣布达成战略合作。本次合作旨在通过整合双方优势技术资源，在自动驾驶毫米波雷达技术与自动驾驶在环仿真验证技术领域，共同推进自动驾驶技术的发展与商业化落地。",
          date: "2022.5.6",
        },
        {
          icon: require("@/static/img/ecosphere/collaborativeImg4.png"),
          href: "https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247487054&idx=1&sn=808daa0d736bdd38fc3ae8f338fce35f&chksm=fcd14119cba6c80f2dcf197782805b21f926775ab273f77a8b33e29454f2059e0124db9c78ad&token=185823960&lang=zh_CN#rd",
          h1: "沛岱汽车与鉴智机器人达成双向战略合作",
          h2: '2022年3月31日，沛岱汽车（PilotD Automotive）与北京鉴智科技有限公司（PhiGent Robotics，以下简称"鉴智机器人"）宣布达成战略合作。双方将依托各自的技术和资源优势，在双目视觉雷达3D稠密重建与自动驾驶仿真验证领域针对实质产品研发达成双向战略合作，共同推进自动驾驶技术的商务落地与技术创新。',
          date: "2022.3.31",
        },
        {
          icon: require("@/static/img/ecosphere/collaborativeImg5.png"),
          href: "https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247486900&idx=1&sn=ebe23a1c10b3f3423da5549eb0d7cfda&chksm=fcd142e3cba6cbf57a7f48dcd0b1bc5bc4ee3738737d3a995b16974fc3bb85142274fbf3e217&token=185823960&lang=zh_CN#rd",
          h1: "沛岱汽车与上海第二工业大学共建在环仿真DiL实验室,构建产学研“朋友圈”",
          h2: "近日，沛岱汽车与上海第二工业大学达成合作，宣布共建“自动驾驶驾驶员在环仿真DiL实验室”，该实验室将对自动驾驶产业和技术发展提供前瞻性洞察和工程化探索。实验室的落地启用意味着沛岱汽车在推进科研平台建设上迈出了里程碑式的一步，产学研“朋友圈”进一步扩大。",
          date: "2021.10.27",
        },
        {
          icon: require("@/static/img/ecosphere/collaborativeImg6.png"),
          href: "https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247486728&idx=1&sn=5f4b695ddb87bec4ef3dd60f4f3fbadc&chksm=fcd1425fcba6cb49e6c4e9d76d5167f7301824b955cbd42f8d9f3485ba3f8681871d88311114&token=185823960&lang=zh_CN#rd",
          h1: "合作共赢！沛岱汽车技术×浙江省智能网联汽车创新中心，共创智慧出行新格局！",
          h2: "8月6日上午，沛岱（上海）汽车技术有限公司与浙江省智能网联汽车创新中心的战略合作及共建研究所签约授牌仪式在创新中心隆重举行，沛岱汽车执行董事兼CEO曹鹏博士、COO章依云出席仪式。在杭州市经济和信息化局汽车产业处处长魏兆宏、萧山区蜀山街道党工委书记楼海锋、萧山区经济和信息化局产业规划总监刘潇、浙江省汽车工业技术创新协会会长卜向红等领导的共同见证下，曹鹏博士与创新中心总经理杨爱喜先生完成《战略合作协议》签约。",
          date: "2021.8.9",
        },
        {
          icon: require("@/static/img/ecosphere/collaborativeImg7.png"),
          href: "https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247485704&idx=1&sn=621e0904b85ad057ad46eb0b2c82c901&chksm=fcd1465fcba6cf495a253f795dbf73a836988aa7bc7633300b3ba21ef2f148b8d70f417efa80&token=185823960&lang=zh_CN#rd",
          h1: "强强联手，打造共赢模式|沛岱汽车与昆易电子科技达成战略合作！",
          h2: "2020年12月9日，沛岱汽车与昆易电子科技战略合作协议签约仪式在上海成功举办，沛岱汽车CEO曹鹏与昆易电子科技CEO陈奇共同出席了本次签约仪式，共同见证这一历史性时刻。 一个是拥有高端仿真技术的实力汽车企业，一个是拥有雄厚的软硬件开发能力的电子科技公司，双方强强联手迎来品牌的全新升级，在自动驾驶HiL硬件在环测试系统领域达成深度合作，打造共赢模式。通过此次战略协议的签署，沛岱汽车与昆易电子定能在自动驾驶领域中大放异彩。",
          date: "2020.2.22",
        },
        {
          icon: require("@/static/img/ecosphere/collaborativeImg8.png"),
          href: "https://mp.weixin.qq.com/s?__biz=MzU3MjQ5NjQ0MA==&mid=2247485545&idx=1&sn=c7fa488d62daef19bb64d054524373ce&chksm=fcd1473ecba6ce28b8814ccbf57acfeaa775b47363a580c07f95ae27c2a53f84cb7e7c111c59&token=185823960&lang=zh_CN#rd",
          h1: "沛岱汽车携手知迪打造V2X全仿真生态，覆盖海量V2X场景仿真测试",
          h2: "沛岱汽车与知迪汽车技术在V2X仿真测试领域深度合作，双方携手打造V2X全仿真生态。PilotD的仿真生态基于V2X通信性能、通信场景、信息传递过程等功能进行构建，可用于模拟和测试多样化场景并进行分析",
          date: "2020.12.16",
        },
      ],
    };
  },
  created() {
    const reloadOnOrientationChange = () => {
      const isLandscape = Math.abs(window.orientation) === 90;
      if (isLandscape) {
        location.reload();
      } else {
        location.reload();
      }
    };
    window.addEventListener("orientationchange", reloadOnOrientationChange);
  },
  mounted() {
    window.addEventListener("scroll", this.scrolling);
    let lang = localStorage.getItem("lang");
    if (lang == "en-US") {
      this.showTestObject = false;
    } else {
      this.showTestObject = true;
    }
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();
    let liElementArr = this.$refs.liRef;
    liElementArr.forEach((item, index) => {
      item.style.animationDuration = (index + 1) * 0.3 + "s";
    });
  },
  methods: {
    scrolling() {
      let that = this;
      // 高精度仿真的自动驾驶“疆域” 滚到可见性超过或等于 50% 时播放
      var observer = new IntersectionObserver(callback, {
        threshold: 0.5, //阈值 当元素的可见性超过或等于 50% 时，回调函数会被触发
      });
      var targetElement = that.$refs.videoTerritory;
      if (targetElement) {
        observer.observe(targetElement);
      }
      function callback(entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 目标元素进入可视区域
            that.$refs.videoTerritory.play();
          } else {
            // 目标元素离开可视区域
            if (that.$refs.videoTerritory) {
              that.$refs.videoTerritory.pause();
              that.$refs.videoTerritory.currentTime = 0;
            }
          }
        });
      }
    },
    handleSizeChange(val) {
      // 改变每页显示的条数
      console.log("每页显示", val);
      this.pagesize = val;
    },
    handleCurrentChange(val) {
      // 切换第几页
      console.log("当前页", val);
      this.currentPage = val;
    },
  },
  beforeDestroy() {
    this.$refs.videoTerritory.pause();
  },
};
</script>
<style>
/* 设置分页的下拉颜色 */
.selectStyle {
  background-color: #0c132b !important;
  color: rgba(255, 255, 255, 0.65);
  border: 1px solid #32456d !important;

  .popper__arrow {
    border-bottom-color: #32456d !important;
  }

  .popper__arrow::after {
    border-bottom-color: #32456d !important;
  }

  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background-color: #32456d;
  }

  .el-select-dropdown__item.selected,
  .el-select-dropdown__item.hover {
    color: rgba(255, 255, 255, 0.65);
  }

  .el-select-dropdown__item {
    color: rgba(255, 255, 255, 0.65);
  }
}
</style>
<style scoped lang="scss">
.landscape-box {
  /* 横屏 */
  /* display: flex;
    flex-direction: column; */
}

.portrait-box {
  /* 竖屏 */
  display: flex;
  flex-direction: column;
}

#multiSensorHiL {
  width: 100%;
  height: 100%;

  @mixin whar($width, $height, $atio) {
    width: $width;
    height: $height;
    aspect-ratio: $atio;
    box-sizing: border-box;
  }

  @mixin bgar($atio) {
    text-align: center;
    margin-right: 1.5rem;
    aspect-ratio: $atio;
    background-size: contain;
    background-repeat: no-repeat;
  }

  @mixin display {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @mixin commitaspct {
    opacity: 1;
    width: 50%;
    aspect-ratio: 720/600;
    background-size: contain;
    background-repeat: no-repeat;
  }

  @mixin fontStyle(
    $fontweight,
    $height,
    $fontSize,
    $lineHeight,
    $letterSpaceing,
    $color
  ) {
    width: fit-content;
    font-weight: $fontweight;
    height: $height;
    font-size: $fontSize;
    font-style: normal;
    line-height: $lineHeight;
    letter-spacing: $letterSpaceing;
    color: $color;
  }

  #multiSensorHiLModule1 {
    background-size: cover;
    @include whar(100%, auto, 1440/480);
    padding: 12.9375rem 0rem 11rem 12.8125rem;

    #multiSensorHiLModule1Text {
      // width: fit-content;
      width: 62rem;
      height: 7.75rem;
      line-height: 3.875rem;

      #multiSensorHiLModule1TextText1 {
        @include fontStyle(
          600,
          3.875rem,
          2.5rem,
          3.875rem,
          0.06944rem,
          rgba(255, 255, 255, 0.85)
        );
      }

      #multiSensorHiLModule1TextText2 {
        opacity: 1;
        margin-top: 0.75rem;
        @include fontStyle(
          400,
          2rem,
          1.0625rem,
          2rem,
          0.06944rem,
          rgba(255, 255, 255, 0.65)
        );
      }
    }
  }

  /* 高精度仿真的自动驾驶“疆域” */
  #territory {
    width: 100%;
    // height: 100vh;

    box-sizing: border-box;
    background: url("@/static/img/territoryBox_bg.png") no-repeat;
    background-size: cover;

    #territoryBox {
      position: relative;
      width: 100%;
      // height: 100%;

      #title {
        position: absolute;
        top: 3.5rem;
        left: 50%;
        transform: translateX(-50%);
        // width: 100%;
        width: 80%;
        color: rgba(255, 255, 255, 0.85);
        text-align: center;
        font-size: 2.25rem;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }

      #img {
        width: 100%;
        // width: 80rem;
        // height: 42.1875rem;
        height: 100%;
        padding-top: 2rem;
        // margin: 0 auto;
        background-color: #08102f;

        #video {
          width: 100%;
          height: 100%;
          // height: 100vh;
          object-fit: contain;
        }
      }
    }
  }

  // 合作咨询
  .collaborativeConsulting {
    padding: 4.875rem 13.75rem;

    .title1 {
      color: rgba(255, 255, 255, 0.85);
      text-align: center;
      font-size: 2.25rem;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    .title2 {
      color: rgba(255, 255, 255, 0.65);
      text-align: center;
      font-size: 1rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1.625rem;
      margin: 1rem 0 2.5rem;
    }

    ul {
      li {
        .a {
          display: flex;
          // justify-content: space-between;
          align-items: center;
          cursor: pointer;
          padding: 2.5rem 0;
          border-bottom: 1px solid #282d45;

          .img {
            width: 16.75rem;
            height: 9.375rem;
            flex-shrink: 0;
            margin-right: 2rem;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .cont {
            .h1 {
              color: rgba(255, 255, 255, 0.85);
              font-size: 1rem;
              font-style: normal;
              font-weight: 500;
              line-height: 1.625rem;
            }

            .h2 {
              color: rgba(255, 255, 255, 0.65);
              text-align: justify;
              font-size: 0.875rem;
              font-style: normal;
              font-weight: 400;
              line-height: 1.75rem;
              margin: 0.75rem 0;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }

            .date {
              display: flex;
              color: rgba(255, 255, 255, 0.65);
              font-size: 0.875rem;
              font-style: normal;
              font-weight: 400;
              line-height: 1.75rem;

              /* 200% */
              .svg {
                width: 0.75rem;
                height: 0.75rem;
                margin-right: 0.3125rem;

                svg {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }
            }
          }
        }
      }
    }

    .pagination {
      padding: 2rem;
      text-align: center;

      ::v-deep .el-pagination.is-background .btn-prev {
        color: rgba(255, 255, 255, 0.65);
        border-radius: 2px;
        background-color: #0c132b;
        border: 1px solid rgba(255, 255, 255, 0.16);
      }

      ::v-deep .el-pagination.is-background .btn-next {
        color: rgba(255, 255, 255, 0.65);
        border-radius: 2px;
        background-color: #0c132b;
        border: 1px solid rgba(255, 255, 255, 0.16);
      }

      ::v-deep .el-pagination.is-background .el-pager li {
        border-radius: 2px;
        background-color: #0c132b;
        border: 1px solid rgba(255, 255, 255, 0.16);
        color: rgba(255, 255, 255, 0.65);

        &:hover {
          color: rgba(255, 255, 255, 0.65);
        }
      }

      ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
        border-radius: 2px;
        border: 1px solid var(--Brand-6-normal, #d71f28);
        background: var(--Brand-6-normal, #d71f28);
      }

      ::v-deep .el-input__inner {
        color: rgba(255, 255, 255, 0.65);
        background-color: #0c132b;
        border: 1px solid rgba(255, 255, 255, 0.16);
      }

      ::v-deep .el-pagination__jump {
        margin-left: 0;
      }
    }
  }

  &.en {
    .collaborativeConsulting {
      ul {
        .h1 {
          line-height: 1.5 !important;
          // text-align: justify !important;
        }
      }
    }
  }
}
</style>
